import { render, staticRenderFns } from "./NewYearCallback.vue?vue&type=template&id=cb2d9646&scoped=true&"
import script from "./NewYearCallback.vue?vue&type=script&lang=js&"
export * from "./NewYearCallback.vue?vue&type=script&lang=js&"
import style0 from "./NewYearCallback.vue?vue&type=style&index=0&id=cb2d9646&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2d9646",
  null
  
)

export default component.exports